import dayjs from 'dayjs';
import { dateToString } from '../../../shared/utils/parseDate.js';

export const LastReview = ({ data }) => {
  function padArrayToFive(arr) {
    while (arr.length < 5) {
      arr.push(null);
    }
    return arr;
  }

  return (
    <div className="col-md-6">
      <div className="review mb-3">
        <div className="review-header">
          <div className="review-user">
            <div
              className="review-avatar"
              style={{
                backgroundImage:
                  'url(https://ui-avatars.com/api/?name=e&color=7F9CF5&background=EBF4FF)',
              }}
            ></div>
            <div className="review-info">
              <div className="name">
                {data.user.name} {data.user.surname}
              </div>
              <div className="rating">
                {padArrayToFive([...Array(data.rate).keys()]).map((rate, index) => (
                  <div key={index} className="rating-var active">
                    <i className={`bi bi-star-fill ${rate === null ? 'text-secondary' : ''}`}></i>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="review-date">{dateToString(data.createdAt)}</div>
        </div>

        <div className="review-body">
          <div className="title">{data.title}</div>
          <div className="content">{data.text}</div>
        </div>
      </div>
    </div>
  );
};
